<template>
  <div>
    <headingComp :heading="'Pontos de Interesse'" :icon="require('@/assets/ic-white-pontos-interesse.svg')" :backgroundImage="require('@/assets/fg-antes-10@3x.jpg')"/>
    
    <div class="filters">
      <div :class="{'active': filter === 'all'}" class="all"><p @click="selectFilter('all')">Todos</p></div>
      <div :class="{'active': filter === 'onde_dormir'}" class="onde_dormir"><p @click="selectFilter('onde_dormir')">Onde Dormir</p></div>
      <div :class="{'active': filter === 'o_que_visitar'}" class="o_que_visitar"><p @click="selectFilter('o_que_visitar')">O que Visitar</p></div>
      <div :class="{'active': filter === 'onde_comer'}" class="onde_comer"><p @click="selectFilter('onde_comer')">Onde Comer</p></div>
      <div :class="{'active': filter === 'onde_comprar'}" class="onde_comprar"><p @click="selectFilter('onde_comprar')">Onde Comprar</p></div>
    </div>

    <section class="content-container">
      <div id="map" />
      <div class="interest-points-container">
        <div class="interest-points" v-if="interestPoints">
          <article v-for="interestPoint in interestPoints" :key="interestPoint.id" 
          :class="[{'selected': interestPoint.id === selectedInterest}, [interestPoint.id]]">
            <interestPoint :interestPoint="interestPoint" />
          </article>
        </div>
      </div>
    </section>

    <!-- <div id="content">
      <div id="siteNotice"></div>
      <h1 id="firstHeading" class="firstHeading">Uluru</h1>
    </div> -->
  </div>
</template>
<script>

//import gmapsInit from '../map';

let image = require('@/assets/interest_point_marker.png')
let imageClick = require('@/assets/interest_point_marker_clicked.png')

export default {
  name: 'pontosDeInteresse',
  props: [],
  components: {
  },
  data() {
    return {
      map: null,
      clickedMarker: null,

      interestPoints: null,
      interestPointsFull: null,

      filter: 'all',
      markers: [],
      selectedInterest: null
    }
  },
  async mounted () {
    if (this.$route.query.type) {
      let type = this.$route.query.type
      if (type === 'onde_dormir' || type === 'o_que_visitar' || type === 'onde_comer' || type === 'onde_comprar') this.filter = type
    }
    if (typeof google === 'undefined') {
      setTimeout(() => this.loadMap(), 1000)
    } else {
      this.loadMap()
    }
    window.addEventListener('scroll', this.scrollEvent)
    window.handleGoInterestPoint = this.goToInterestPoint

    const footer = document.body.querySelector('.apps');

    footer.style.marginTop = '0px';
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    scrollEvent (e) {
      if (window.pageYOffset > window.innerHeight) {
        this.$el.querySelector('.filters').style.position = 'fixed'
      } else {
        this.$el.querySelector('.filters').style.position = 'relative'
      }
    },
    goToInterestPoint(id){
      this.$router.push(`/pontoDeInteresse/${id}`)
    },
    async loadMap () {
      try {
        this.interestPoints = await this.api.get('interestPoint')
        this.interestPointsFull = [...this.interestPoints]
        var uluru = {lat: Number(38.8802201), lng: Number(-7.1627818)};
        let map = new google.maps.Map(document.getElementById('map'), {
          zoom: 17,
          center: uluru,
          mapTypeId: 'satellite',
          disableDefaultUI: true,
          scrollwheel: true,
          draggable: true
        })
        this.map = map
        this.addMarkers()
        //this.calculateDirection(interestPoints)
        

      } catch (error) {
        console.error(error);
      }
    },
    calculateDirection (interestPoints) {
      var directionsService = new google.maps.DirectionsService;
        
      if (localStorage.getItem('route-1')) {
        let result = JSON.parse(localStorage.getItem('route'))
        this.drawLegs(result);
      } else {
        directionsService.route({
          origin: interestPoints[0],
          destination: interestPoints[2],
          waypoints: [{location: interestPoints[1]}],
          travelMode: 'WALKING'
        }, function (response) {
            localStorage.setItem('route-1', JSON.stringify(response))
            this.drawLegs(response);
        })
      }
    },
    drawLegs (result) {
      let modifiedResult, line, displayDirection
      for(var i = 0; i < result.routes[0].legs.length; i++){
        modifiedResult = JSON.parse(JSON.stringify(result))
        modifiedResult.request = result.request
        modifiedResult.geocoded_waypoints = []
        modifiedResult.geocoded_waypoints.push(result.geocoded_waypoints[i])
        modifiedResult.geocoded_waypoints.push(result.geocoded_waypoints[i+1])
        modifiedResult.routes[0].legs = [result.routes[0].legs[i]]

        line = {
          strokeColor: '#fff',
          strokeOpacity: 1,
          strokeWeight: 5
        }

        displayDirection = new google.maps.DirectionsRenderer({polylineOptions : line, suppressMarkers : true, preserveViewport : true})

        displayDirection.setMap(this.map)
        displayDirection.setDirections(modifiedResult)

        modifiedResult = null
      }
    },
    addMarkers () {
      this.markers.forEach(marker => {
        marker.setMap(null)
      })
      let interestPointsMarkers = []

      const infowindow = new google.maps.InfoWindow({
        content: null
      });

      this.interestPoints.forEach (point => {
        interestPointsMarkers.push(new google.maps.LatLng(point.lat, point.lng))
      })
      interestPointsMarkers.forEach(point => {
        let marker = new google.maps.Marker({
          position: point,
          icon: image,
          map: this.map,
          info: this.interestPoints.find(item => point.lat() === item.lat
           && point.lng() === item.lng)
        })


        marker.addListener('click', () => {
          marker.setIcon(imageClick)
          if (this.clickedMarker) this.clickedMarker.setIcon(image)
          this.clickedMarker = marker
          const element = document.body.getElementsByClassName(`${marker.info.id}`)[0]
          const documentSize = document.body.getBoundingClientRect()



          if(this.selectedInterest === marker.info.id) {
            return;
          }
          this.selectedInterest = marker.info.id

          if(documentSize.width > 600){
            window.scrollTo({
              top: element.getBoundingClientRect().top - documentSize.top - 140,
              behavior: 'smooth'
            })
          } else {
            const pointsCointainer = document.body.querySelector('.interest-points')

            pointsCointainer.scrollTo({
              left: element.offsetLeft,
              behavior: 'smooth'
            })
          }
        })
        marker.addListener('mouseover', () => {
          infowindow.setContent(
            `<div onclick="handleGoInterestPoint('${marker.info.id}')">` +
            `<h1 class="info-window-title">${marker.info.translation.title}</h1>` +
            `<p class="info-window-body">${marker.info.subtype}</p>` +
            '<div>' +
            "</div>" +
            "</div>"
          )
          marker.setIcon(imageClick)
          infowindow.open({
            anchor: marker,
            map: this.map,
            shouldFocus: false
          })
        })
        marker.addListener('mouseout', () => {
          marker.setIcon(image)
        })
        this.markers.push(marker)
      })
    },
    selectFilter(filter) {
      if (filter === this.filter) return
      this.filter = filter
      if (filter === 'all') this.interestPoints = this.interestPointsFull
      else {
        this.interestPoints = this.interestPointsFull.filter(point => point.type === filter)
      }
      this.addMarkers()
    }
  }
}
</script>
<style>
  .gm-style-iw-c {
    border-radius: 0;
    padding: 8px;
    cursor: pointer;
  }
  .info-window-title {
    font-family: Sen;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #67641e;
  }

  .info-window-body {
    font-family: Sen;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #67641e;
  }
</style>
<style lang="scss" scoped>
#map {
  width: 50vw;
  height: 100vh;
  min-height: 500px;
  position: fixed!important;
  top: 0;

  @media (max-width: 600px){
    width: 100vw;
    min-height: 70vh;
    max-height: 70vh;
    position: relative !important;
  }
}

.interest-points-container {
  width: 50vw;
  margin-left: 50vw;
  padding-top: 40px;
  background: #f6ede0;
  .interest-points {
    display: flex;
    flex-wrap: wrap;
  }
  .interest-points article {
    width: calc(100% / 2 - 30px);
    margin: 0 20px;
    border: 2px solid transparent;

    &:nth-of-type(even) {
      margin: 2px 18px 2px 8px;

    }
    &:nth-of-type(odd) {
      margin: 2px 8px 2px 18px;
    }

    &.selected /deep/ .interest-point-item {
      h2, p {
        color: #f6b92f;
      }
    }
  }
  .interest-points article /deep/ .interest-point-item {
      margin-bottom: 40px;
      position: relative;

      & > .image {
        max-height: 200px;
        width: 100%;
        img {
          width: 100%;
        }
      }
      h2 {
        font-weight: bold;
        font-size: 18px;
        line-height: 1.22;
        letter-spacing: -0.4px;
        color: #a79374;
        margin-top: 16px;
      }
      p {
        font-size: 16px;
        line-height: 1.5;
        color: #a79374;
      }
  }

  @media (max-width: 600px){
    width: 100vw;
    margin-left: 0;
    height: 30vh;
    min-height: 200px;
    overflow: hidden;
    padding: 0px;
    .interest-points {
      display: grid;
      grid-template-columns: repeat(2, 33%);
      grid-template-rows: repeat(1, 30vh);
      grid-auto-columns: 33%;
      grid-auto-flow: column;
      overflow-y: scroll;
      column-gap: 30px;
      margin-top: 8px;
      padding: 8px 12px;
    }
    .interest-points article {
      width: 100%;
      margin: 0;

      &:nth-of-type(even) {
        margin: 0;
      }
      &:nth-of-type(odd) {
        margin: 0;
      }
    }

    .interest-points article /deep/ .interest-point-item {
      margin-bottom: 40px;
      position: relative;

      & > .image {
        max-height: 200px;
        width: 100%;
        img {
          width: 100%;
        }
      }
      h2 {
        font-size: 16px;
        margin-top: 8px;
      }
      p {
        font-size: 14px;
        line-height: 1.5;
        color: #a79374;
      }
    }
  }
}
h1 {
  font-size: 80px;
  display: table;
}
h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
}
.title {
  position: absolute;
  font-size: 84px;
  right: 0;
  top: -75px;
  z-index: 1;
}
.filters {
  display: flex;
  justify-content: center;
  width:  100%; 
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  align-items: center;
  z-index: 15;
  position: relative;
  top: 0;
  left: 0;
  div {
    height: 74px;
    display: flex;
    align-items: center;
    opacity: 0.5;
    border-bottom: 2px solid transparent;
    &.active {
      opacity: 1;
    }
    &.all {
       color: #f6b92f;
       &.active {
        opacity: 1;
      }
    }
    &.onde_comer {
      p {
        color: #0d3677;
      }
    }
    &.onde_dormir {
      p {
       color: #b32a2e;
      }
    }
    &.o_que_visitar {
      p {
        color: #67641e;
      }
    }
    &.onde_comprar {
      p {
        color: #6c30a9;
      }
    }
  }
  p {
    color: #f6b92f;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.67;
    letter-spacing: -0.4px;
    padding: 0 20px;
    cursor: pointer;
  }

  @media (max-width: 700px){
    p {
      font-size: 16px;
    }
  }

  @media (max-width: 500px){
    p {
      font-size: 14px;
      padding: 10px
    }
  }
}
.content-container {
  display: flex;

  @media (max-width: 600px){
    flex-direction: column;
  }
}
</style>